import { useQuery } from '@tanstack/react-query';
import { useApi } from '@mainstage/core-plugin-api';
import { featureRequestRequesterApiRef } from '../../apis';

export const useFeatureRequestProjectsReceived = () => {
  const api = useApi(featureRequestRequesterApiRef);

  return useQuery({
    queryKey: ['feature-requests', 'received', 'projects'],
    queryFn: () => api.fetchProjectsReceived(),
    staleTime: 5 * 60 * 1000,
  });
};
